import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/lamariaadmin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </LanguageProvider>
    </div>
  );
}

export default App;
